import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  deliveryBox: {
    backgroundColor: '$colorBgPrimaryLight',
    padding: '$space6',
  },
});
